import React, { useEffect, useState } from "react";
import PublicLayout from "../components/PublicLayout";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";
import { Phone, Mail, MapPin, MessageSquare } from "lucide-react";
import WhatsAppIcon from "../components/WhatsAppIcon";
import { useT } from "../lib/i18n";

export default function Contact() {
  const t = useT();
  const [c, setC] = useState({ name:"Shruti Tours & Travels", phone:"+91 9890201047", email:"shrutitandt@gmail.com" });
  const [f, setF] = useState({ customer_name:"", customer_mobile:"", customer_email:"", from_place:"", to_place:"", passengers:1, notes:"" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(()=>{ api.get("/company").then(r=>setC(r.data)).catch(()=>{}); }, []);
  const waNumber = (c.phone||"").replace(/\D/g,'');

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/leads", { ...f, booking_type:"custom", passengers: parseInt(f.passengers)||1, source: "contact_form" });
      setSent(true); toast.success("Message sent! We'll reach out shortly.");
      setF({ customer_name:"", customer_mobile:"", customer_email:"", from_place:"", to_place:"", passengers:1, notes:"" });
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
    setLoading(false);
  };

  return (
    <PublicLayout>
      <section className="max-w-5xl mx-auto px-4 pt-10 pb-16">
        <div className="text-xs uppercase tracking-widest text-[var(--brand-orange)] font-semibold">{t("contact.eyebrow")}</div>
        <h1 className="text-4xl sm:text-5xl font-display font-black tracking-tight">{t("contact.title")}</h1>

        <div className="grid md:grid-cols-3 gap-6 mt-10">
          <a href={`tel:${c.phone}`} className="card-lift p-6 rounded-xl bg-white border border-slate-200" data-testid="contact-phone">
            <Phone className="w-6 h-6 text-[var(--brand-orange)]" />
            <div className="font-display font-bold text-lg mt-3">Call</div>
            <div className="text-sm text-slate-600 mt-1">{c.phone}</div>
          </a>
          <a href={`https://wa.me/${waNumber}`} target="_blank" rel="noreferrer" className="card-lift p-6 rounded-xl bg-white border border-slate-200" data-testid="contact-whatsapp">
            <WhatsAppIcon className="w-6 h-6 text-[#25D366]" />
            <div className="font-display font-bold text-lg mt-3">WhatsApp</div>
            <div className="text-sm text-slate-600 mt-1">{c.phone}</div>
          </a>
          <a href={`mailto:${c.email}`} className="card-lift p-6 rounded-xl bg-white border border-slate-200" data-testid="contact-email">
            <Mail className="w-6 h-6 text-[var(--brand-orange)]" />
            <div className="font-display font-bold text-lg mt-3">Email</div>
            <div className="text-sm text-slate-600 mt-1">{c.email}</div>
          </a>
        </div>

        <div className="mt-10 grid md:grid-cols-5 gap-6">
          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-widest text-[var(--brand-orange)] font-semibold flex items-center gap-2"><MessageSquare className="w-3.5 h-3.5" /> Send us a message</div>
            <h2 className="text-2xl font-display font-bold tracking-tight mt-1">Get a quick quote</h2>
            <p className="text-sm text-slate-500 mt-2 leading-relaxed">Share your trip details — our team will send a personalised quote on WhatsApp within an hour.</p>
            <div className="mt-4 p-4 rounded-xl bg-[var(--brand-navy)] text-white text-sm">
              <div className="flex items-center gap-2 font-semibold"><MapPin className="w-4 h-4 text-[var(--brand-orange)]" /> Office</div>
              <div className="text-white/70 mt-1 text-xs">Pune, Maharashtra · Serving all of India</div>
            </div>
          </div>
          <form onSubmit={submit} className="md:col-span-3 p-6 rounded-2xl bg-white border border-slate-200 grid md:grid-cols-2 gap-3" data-testid="contact-form">
            <div><Label>Name *</Label><Input required value={f.customer_name} onChange={e=>setF({...f,customer_name:e.target.value})} data-testid="cf-name" /></div>
            <div><Label>Mobile *</Label><Input required value={f.customer_mobile} onChange={e=>setF({...f,customer_mobile:e.target.value})} data-testid="cf-mobile" /></div>
            <div className="md:col-span-2"><Label>Email</Label><Input type="email" value={f.customer_email} onChange={e=>setF({...f,customer_email:e.target.value})} /></div>
            <div><Label>From</Label><Input value={f.from_place} onChange={e=>setF({...f,from_place:e.target.value})} placeholder="Pickup city" /></div>
            <div><Label>To</Label><Input value={f.to_place} onChange={e=>setF({...f,to_place:e.target.value})} placeholder="Destination" /></div>
            <div className="md:col-span-2"><Label>Passengers</Label><Input type="number" min="1" value={f.passengers} onChange={e=>setF({...f,passengers:e.target.value})} /></div>
            <div className="md:col-span-2"><Label>Message *</Label><Textarea required value={f.notes} onChange={e=>setF({...f,notes:e.target.value})} placeholder="Trip details, dates, any special request…" data-testid="cf-notes" /></div>
            <Button disabled={loading} type="submit" className="md:col-span-2 bg-[#ea580c] hover:bg-orange-700" data-testid="cf-submit">{loading?"Sending…":sent?"Sent — send another?":"Send Message"}</Button>
          </form>
        </div>
      </section>
    </PublicLayout>
  );
}
